var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-dropdown-search-selection.ts
import {
  ElementsDropdownSearchSelection,
  ElementsDropdownSearchSelectionContent
} from "@adornis/popover/x-dropdown-search-selection";
import { customElement } from "lit/decorators.js";
import "./ge-input";
var GermaniumDropdownSearchSelection = class extends ElementsDropdownSearchSelection {
  // override _trigger() {
  //   return html`
  //     <ge-input
  //       ${injectAttributesOf(this, ['tabindex'])}
  //       ${ref(this._inputReference)}
  //       .value=${live(
  //         this._searchString.value === undefined
  //           ? this.renderSelected(this.value.value as any)
  //           : this._searchString.value,
  //       )}
  //       @value-changed=${(e: CustomEvent) => {
  //         if (this._searchString.value !== e.detail.value) {
  //           this._searchString.next(e.detail.value);
  //         }
  //       }}
  //       @icon-click=${() => this.dispatchEvent(new CustomEvent('icon-click'))}
  //       @cleared=${() => this._clear()}
  //       @focus=${() => this._onFocus()}
  //       @blur=${() => this._onBlur()}
  //     ></ge-input>
  //   `;
  // }
};
GermaniumDropdownSearchSelection = __decorateClass([
  customElement("ge-dropdown-search-selection")
], GermaniumDropdownSearchSelection);
var GermaniumDropdownSearchSelectionContent = class extends ElementsDropdownSearchSelectionContent {
};
GermaniumDropdownSearchSelectionContent = __decorateClass([
  customElement("ge-dropdown-search-selection-content")
], GermaniumDropdownSearchSelectionContent);
export {
  GermaniumDropdownSearchSelection,
  GermaniumDropdownSearchSelectionContent
};
